import React from 'react';
import PropTypes, { checkPropTypes } from 'prop-types';
import { useParams, Navigate } from 'react-router-dom';
import { toggleVisibility, postMessage } from '../modules/core/services/coreIFrameHelper';

const AuthComponent = (props) => {
  const {
    authenticated = defaultProps.authenticated,
    location = defaultProps.location,
    RouteComponent = defaultProps.RouteComponent,
    rest = defaultProps.rest,
    redirectUrl = defaultProps.redirectUrl
  } = props;
  checkPropTypes(AuthComponent.propTypes, props, 'prop', AuthComponent.name);
  const params = useParams();
  if (authenticated) {
    // If navigating to rcore route then hide the iframe
    if (location.pathname.toLowerCase() === '/rcore/c') {
      // Rerouting the /c to /c/
      location.assign('/rcore/c/');
      return;
    }
    if (rest.path !== '/' && rest.path !== '/c') {
      postMessage('CLOSE_CURRENT_SLIDEOUT');
      toggleVisibility(false);
      return (
        <div>
          <RouteComponent {...params} />
        </div>
      );
    }
    return <RouteComponent {...params} />;
  }
  return <Navigate to={redirectUrl} replace />;
};

AuthComponent.propTypes = {
  /**
   * specifies, if the route is authenticated
   */
  authenticated: PropTypes.bool,
  /**
   * window location object
   */
  location: PropTypes.shape({
    pathname: PropTypes.string,
    assign: PropTypes.func
  }),
  /**
   * Component to be rendered
   */
  RouteComponent: PropTypes.shape({}),
  /**
   * path
   */
  rest: PropTypes.shape({
    path: PropTypes.string
  }),
  /**
   * redirect url, if the route is not authenticated
   */
  redirectUrl: PropTypes.string
};

const defaultProps = {
  authenticated: false,
  location: {
    pathname: '/',
    assign: () => {}
  },
  RouteComponent: undefined,
  rest: {
    path: '/'
  },
  redirectUrl: '/'
};

export default AuthComponent;
